import { useEffect, useSyncExternalStore } from 'react'

// The phone floating Scan button (ScanFab) sits bottom-right, which is also
// where the Deck Chat pill lives on phones. A component that owns that corner
// (DeckChatDock, while mounted) hides the button so the two never stack. Same
// ref-counted mounted-flag pattern as mobileNavSuppression.ts: set while the
// holder is mounted, cleared on unmount, StrictMode-safe.

let holders = 0
const listeners = new Set<() => void>()
const emit = () => { for (const l of listeners) l() }

function subscribe(listener: () => void) {
  listeners.add(listener)
  return () => { listeners.delete(listener) }
}

/** Hide the floating Scan button while `active` is true and this component is mounted. */
export function useSuppressScanFab(active: boolean) {
  useEffect(() => {
    if (!active) return
    holders += 1
    emit()
    return () => {
      holders -= 1
      emit()
    }
  }, [active])
}

/** True while any mounted component suppresses the floating Scan button. */
export function useScanFabSuppressed(): boolean {
  return useSyncExternalStore(subscribe, () => holders > 0, () => false)
}
